import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Version } from '@/global/types/common.type';

import { REDUX_SLICE } from '../constants';
import { AppSliceState } from '../types/app.type';

const initialState: AppSliceState = {
  chainId: 0,
  nodeId: '',
  nftId: '',
  nodeVersion: 'v1',
  referralCode: '',
  address: '',
};

export const appSlice = createSlice({
  name: REDUX_SLICE.APP,
  initialState,
  reducers: {
    setChainId: (state, action: PayloadAction<number>) => {
      state.chainId = action.payload;
    },
    setNodeId: (state, action: PayloadAction<string>) => {
      state.nodeId = action.payload;
    },
    setNftId: (state, action: PayloadAction<string>) => {
      state.nftId = action.payload;
    },
    setNodeVersion: (state, action: PayloadAction<Version>) => {
      state.nodeVersion = action.payload;
    },
    setReferralCode: (state, action: PayloadAction<string>) => {
      state.referralCode = action.payload;
    },
    setReceivedAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
  },
});
